import React, { useEffect } from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { loadRestaurant } from "../redux/actions/baseActions";
import OrderPage from "../pages/order/OrderPage";
import OrderPageNew from "../pages/order/OrderPageNew";
import ClientPage from "../pages/payment/ClientPage";
import PaymentPage from "../pages/payment/PaymentPage";
import { getImageUrl } from "../api/iposApi";
import AddItemPage from "../pages/add_item/AddItemPage";
import AddBlItemPage from "../pages/add_item/AddBlItemPage";
import AddItemHeader from "./components/AddItemHeader";
import { isMobileAndTablet } from "../helpers/common";
import PaymentSuccessPage from "../pages/payment/PaymentSuccessPage";
import useIdleTimer from "../hooks/useIdelTimer";
import HeaderNew from "./components/HeaderNew";

function RestaurantLayout({ loadRestaurant, currentLanguageId, branchInfo }) {
  const { branchId } = useParams();
  const history = useHistory();
  const location = useLocation();

  const isAddItemPage =
    location.pathname.includes("add_item") ||
    location.pathname.includes("add_bl_item");
  const isMobile = isMobileAndTablet();

  const refreshOrder = () => {
    if (branchInfo && branchInfo.branch_guid_code) {
      history.push(`/${branchInfo.branch_guid_code}/type`);
    }

    window.location.reload();
  };

  useIdleTimer(refreshOrder);

  const fetchData = async () => {
    try {
      const res = await loadRestaurant(branchId, true);

      if (res && res.error_message) {
        history.push(`/${branchId}/error`);
      }
    } catch (e) {
      history.push(`/${branchId}/error`);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentLanguageId]);

  return (
    <>
      {/* <div
        className={`restaurant-layout ${
          isAddItemPage ? "add-item-layout" : ""
        } ${isMobile ? "mobile" : ""}`}
        id={"scrollable-restaurant-layout"}
        style={{
          backgroundImage: `url(${getImageUrl(branchInfo.BannerImageName)})`,
        }}
      > */}
      <div
        className={"restaurant-layout"}
        style={{
          backgroundImage: `url(${getImageUrl(branchInfo.BannerImageName)})`,
        }}
      >
        <HeaderNew />
        {/* {!isMobile && <AddItemHeader />} */}

        <Switch>
          <Route exact path="/:branchId/order" component={OrderPageNew} />
          <Route exact path="/:branchId/order/:tableId" component={OrderPageNew} />
          {/* <Route exact path="/:branchId/order" component={OrderPage} />
          <Route exact path="/:branchId/order/:tableId" component={OrderPage} /> */}
          <Route exact path="/:branchId/client" component={ClientPage} />
          <Route exact path="/:branchId/payment" component={PaymentPage} />
          <Route exact path="/:branchId/add_item" component={AddItemPage} />
          <Route
            exact
            path="/:branchId/add_bl_item"
            component={AddBlItemPage}
          />
        </Switch>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  const { currentLanguageId, branchInfo } = state;

  return {
    currentLanguageId,
    branchInfo,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadRestaurant,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantLayout);
